import React from "react";
import { withRouter } from "react-router-dom";

import { Typography, IconButton, Grid } from "@material-ui/core";
import { MdShortText } from "react-icons/md";
import { TiBusinessCard } from "react-icons/ti";
import { FiShare } from "react-icons/fi";
import {
  Backbutton,
  Loader,
  ProfileDashboard,
  Tabs,
  Button
} from "../../components/_common";
import { Layout, Section } from "../../components/_layout";
import { CampaignInfo, OwnerInfo } from "../../components/CampaignsModule";

import { useCampaignDetail, useCampaignSubscription } from "../../hooks";

import useStyles from "./styles";

const CampaignDetail = ({ match }) => {
  const [
    { campaignDetail, loadingCampaignDetail, fetchData }
  ] = useCampaignDetail(match.params.id);

  const [
    { isUserSubscribed, subscribeToCampaign }
  ] = useCampaignSubscription(parseInt(match.params.id), () =>
    fetchData(match.params.id)
  );

  const {
    title,
    cdRoot,
    cdAvatar,
    cdSubscribeContainer,
    cdButtonLabel,
    cdSubscribeButton
  } = useStyles({
    campaignDetail
  });

  if (loadingCampaignDetail) {
    return (
      <Layout
        leftContainerChildren={<Backbutton />}
        centerContainerChildren={<Loader size={24} />}
      >
        <Loader />
      </Layout>
    );
  }

  const { title: campaignTitle, campaign_subscriptions } = campaignDetail;

  return (
    <Layout
      leftContainerChildren={<Backbutton />}
      centerContainerChildren={
        <Typography className={title} noWrap>
          {campaignTitle}
        </Typography>
      }
      rightContainerChildren={
        <IconButton>
          <FiShare />
        </IconButton>
      }
    >
      <Grid container className={cdRoot}>
        <Section>
          <Grid item container className={cdAvatar} />
          <ProfileDashboard
            data={[
              { title: "Suscripciones", value: campaign_subscriptions.length },
              { title: "Aceptados", value: campaign_subscriptions.length }
            ]}
          />
          <Grid item container className={cdSubscribeContainer}>
            <Grid item xs className={cdSubscribeButton}>
              <Button
                small
                bold
                className={cdButtonLabel}
                handleClick={subscribeToCampaign}
              >
                {isUserSubscribed ? "Darse de baja" : "Suscribirse"}
              </Button>
            </Grid>
            <Grid item xs className={cdSubscribeButton}>
              <Button
                small
                bold
                secondary
                className={cdButtonLabel}
                handleClick={subscribeToCampaign}
              >
                Me interesa
              </Button>
            </Grid>
          </Grid>
        </Section>

        <Tabs
          tabs={[
            {
              title: "Info",
              icon: <MdShortText fontSize="inherit" />,
              component: <CampaignInfo data={campaignDetail} />,
              renders: true
            },
            {
              title: "Empresa",
              icon: <TiBusinessCard fontSize="inherit" />,
              component: <OwnerInfo data={campaignDetail} />,
              renders: true
            }
          ]}
        />
      </Grid>
    </Layout>
  );
};

export default withRouter(CampaignDetail);
